export const PORTA_DOMAIN = 'porta.wtg.cloud';
